export default __webpack_public_path__ + "d2bda6197e0547e2c15c2c84dd02b1d6.svg";